import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiCommodityList extends Layout {
    layoutheaderEdiCommodityList: LayoutHeader;
    sourceEdiCommodity: DataSource;
    tableEdiCommodities: Table;
}
